import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { roleGuard } from 'app/core/auth/guards/role.guard';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    {path: '', pathMatch : 'full', redirectTo: 'dashboard'},

    // Redirect signed-in user to the '/users'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'dashboard'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: '404', loadChildren: () => import('app/modules/errors/404/404.routes')},
            {path: '403', loadChildren: () => import('app/modules/errors/403/403.routes')},
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {path: 'client/get-quote', loadChildren: () => import('app/modules/client/get-quote/get-quote.routes')},
            {path: 'get-quote', loadChildren: () => import('app/modules/sales/get-quote/get-quote.routes')},
            {path: 'clients', loadChildren: () => import('app/modules/admin/clients/clients.routes')},
            {path: 'carriers', loadChildren: () => import('app/modules/admin/carriers/carriers.routes')},
            {path: 'airports', loadChildren: () => import('app/modules/admin/airports/airports.routes')},
            {path: 'dashboard', loadChildren: () => import('app/modules/dashboard/dashboard.routes')},
            {path: 'departments', loadChildren: () => import('app/modules/admin/departments/departments.routes')},
            {path: 'providers', loadChildren: () => import('app/modules/admin/providers/providers.routes')},
            {path: 'users', loadChildren: () => import('app/modules/admin/users/users.routes')},
            {path: 'pricing/quotes', canActivate: [roleGuard(['admin', 'pricing'])], canActivateChild: [roleGuard(['admin', 'pricing'])], loadChildren: () => import('app/modules/pricing/quotes/quotes.routes')},
        ]
    }
];
